import { createContext, useContext, useEffect, useState } from "react";

const WishlistContext = createContext(null);
const KEY = "furn_wishlist";

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const has = (id) => items.some((i) => i.product_id === id);
  const toggle = (product) => {
    setItems((prev) => {
      if (prev.some((i) => i.product_id === product.id))
        return prev.filter((i) => i.product_id !== product.id);
      return [
        ...prev,
        {
          product_id: product.id,
          slug: product.slug,
          name: product.name,
          brand: product.brand,
          price: product.sale_price || product.price,
          image: product.images?.[0],
        },
      ];
    });
  };
  const remove = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));

  return (
    <WishlistContext.Provider value={{ items, has, toggle, remove, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
